import React from 'react';
import styled from "styled-components";
import IconCloseUi from "../../../../../shared/ui/icons/icon-close.ui";
import {GLOBAL_STYLE_CONFIG} from "../../../../../app/styles/GlobalStyles";

const StyleSelectedItem = styled.button`
    background-color: var(${GLOBAL_STYLE_CONFIG.variable('tag', 'bg-color')},
    ${({theme}) => theme.filterSelectedTag.bgColor});
    border-width: 1px;
    border-style: solid;
    border-color: var(${GLOBAL_STYLE_CONFIG.variable('tag', 'border-color')},
    ${({theme}) => theme.filterSelectedTag.borderColor});
    border-radius: var(${GLOBAL_STYLE_CONFIG.variable('tag', 'border-radius')},
    ${({theme}) => theme.filterSelectedTag.borderRadius});
    padding: var(${GLOBAL_STYLE_CONFIG.variable('tag', 'padding')}, 9px 15px);
    font-size: var(${GLOBAL_STYLE_CONFIG.variable('tag', 'font-size')}, 9px 15px) clamp(14px, 2vw, 16px);
    display: flex;
    align-items: center;
    gap: 8px;
    width: max-content;
    max-width: 100%;
    color:  var(${GLOBAL_STYLE_CONFIG.variable('tag', 'text-color')},
            ${({theme}) => theme.colors.dark});
    cursor: pointer;

    svg path {
        fill: var(${GLOBAL_STYLE_CONFIG.variable('tag', 'text-color')},
        ${({theme}) => theme.colors.dark});;
    }

    &:hover {
        border-color:
                var(${GLOBAL_STYLE_CONFIG.variable('tag', 'hover-border-color')},
                ${({theme}) => theme.filterSelectedTag.hoverBorderColor});
    }

`

interface IProps {
    title: string;
    onUnSelected: () => void;

}

/**
 * * Компонент, отображающий выбранный фильтр в виде "чипса".
 *
 * @param {string} title  - Название параметра фильтра.
 * @param {function} onUnSelected  -Метод удаления фильтра.
 * @returns {} -
 */
const SelectedItem = ({title, onUnSelected}: IProps) => {
    return (
        <StyleSelectedItem onClick={onUnSelected} className={GLOBAL_STYLE_CONFIG.splitByPrefix("filter-selected-tag")}>
            {title} <IconCloseUi width={12} height={12}/>
        </StyleSelectedItem>
    );
};

export default SelectedItem;